import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link, useHistory } from 'react-router-dom';
import classNames from 'classnames';
import DropdownIcon from 'components/atoms/icons/dropdownIcon';
import { Collapse } from 'reactstrap';

const MenuItemDropDown = ({ label, options, onClick }) => {
  const { location } = useHistory();
  const [colapsed, toogleColapsed] = useState(false);

  return (
    <div className="menu__item menu-item menu-item--dropdown">
      <h4
        className="menu-item__title"
        onClick={() => toogleColapsed(!colapsed)}
      >
        {label}
        <div
          className={classNames('menu-item--dropdown__arrowbtn', 'arrowbtn', {
            'arrowbtn--active': colapsed,
          })}
        >
          <DropdownIcon />
        </div>
      </h4>
      <Collapse isOpen={colapsed}>
        <ul className="menu__list">
          {options.map((el, key) => {
            if (el.type === 'btn') {
              return (
                <div
                  key={key}
                  className="menu-item menu__item--options"
                  onClick={() => {
                    onClick();
                    el.handler();
                  }}
                >
                  {el.label}
                </div>
              );
            }
            if (el.type === 'windows-link') {
              return (
                <div
                  key={key}
                  className="menu-item menu__item--options"
                  onClick={() => {
                    onClick();
                    window.open(el.link, '_blank');
                  }}
                >
                  {el.label}
                </div>
              );
            }

            return (
              <Link
                key={key}
                className={classNames('menu-item menu__item--options', {
                  'option--active': location.pathname === el.link,
                })}
                onClick={onClick}
                to={el.link}
              >
                {el.label}
              </Link>
            );
          })}
        </ul>
      </Collapse>
    </div>
  );
};

MenuItemDropDown.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape()),
  onClick: PropTypes.func,
};

export default MenuItemDropDown;
